module.exports = __webpack_public_path__ + "img/spellweaver.e6f774aa.png";